import Particles from 'react-particles-js';

import './Header.css';
import particlesParams from './particlesParams';
import GitHubButton from './GitHubButton';

function Header() {
  const onMIRClick = () => { window.open('http://mirlab.org/'); };
  return (
    <header className="header">
      <Particles
        className="header__bg"
        params={particlesParams}
      />
      <div onClick={onMIRClick} className="header__mirlab">
        <span className="header--orange">MIR</span> Lab
      </div>
      <div>Singing Voice Conversion Demo</div>
      <GitHubButton />
    </header>
  );
}

export default Header;
